var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTvBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "205px",
    height: "53px",
    viewBox: "0 0 205 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tv-bottom") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home---photos",
    transform: "translate(-382.000000, -5175.000000)",
    fill: "#0A303A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(251.000000, 4814.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tv-bg",
    transform: "translate(0.001844, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.998156,361.205317 C329.352289,361.219828 326.769222,361.038616 308.055441,361.55427 C318.070133,377.582071 326.008499,390.267755 335.097689,404.851322 C309.022007,413.555931 301.186825,396.517922 296.662498,384.430007 C285.105303,353.550403 228.451722,366.50466 224.482802,365.989005 C189.564309,361.471575 169.142192,384.924855 148.026211,407.51229 L148.005679,407.491664 C144.920988,409.863833 141.507159,411.782184 137.867271,413.205317 C119.15349,385.296084 155.329,382.670754 163.100105,369.041744 C166.998156,362.205317 124.574205,361.205317 131.998156,361.205317 C198.998156,361.205317 219.215522,360.743354 325.998156,361.205317 Z",
    id: "tv-bottom"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvBottom);
export default __webpack_public_path__ + "static/media/tv-bottom.cfae3d3abe28aaf5ffda488687501fdc.svg";
export { ForwardRef as ReactComponent };